import removeCommas from "./removeCommas";

export default function numberFormat(str) {
  if (!str) return;
  var num = ("" + removeCommas(str))
    .replace(/(\d)(?=(?:\d{3})+(?:\.|$))|(\.\d\d?)\d*$/g, function (m, s1, s2) {
      return s2 || s1 + ",";
    })
    .toLocaleString("en-US", { maximumFractionDigits: 3 });
  var end = num.indexOf(".") < 0 ? num.length : num.indexOf(".") + 4;
  return num.substring(0, end);
}
